<template>
    <div :data-type="type" class="form-item-textarea-input">
        <div class="d-flex flex-row">
            <label v-if="enumeration != ''" class="text-color-number mb-1">
                {{ enumeration }}
            </label>
            <label v-if="placeholder == false || placeholder == undefined || placeholder == 0"
                   id="formulate-global-1_label" for="formulate-global-1"
                   :for="'form-global-' + fieldId"
                   :class="labelClass" class="mb-1 ps-2">
                <span v-if="required">* </span>{{ label }}
            </label>
        </div>
        <div class="form-input-help mb-1">{{ helpText }}</div>
        <textarea
            :id="'form-global-' + fieldId"
            :name="name"
            :class="[inputClass, { 'is-invalid': shouldShowError }]"
            :placeholder="textPlaceholder"
            :rows="limitSize"
            @input="onInput"
            v-model="modelData"></textarea>
        <div v-if="shouldShowError" class="has-error-msg invalid-feedback d-block">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script setup>
import { computed, nextTick, watch } from 'vue';
import { useField } from 'vee-validate';

// INITIALIZE STORE & COMPOSABLES

// PROPS & EMITS
const props = defineProps({
    enumeration: {
        type: String,
        required: false,
        default: '',
    },
    errorText: {
        type: String,
        required: false,
    },
    fieldId: {
        type: Number,
        required: true,
    },
    helpText: {
        type: String,
        required: false,
    },
    inputClass: {
        type: String,
        required: false,
    },
    label: {
        type: String,
        required: true,
    },
    labelClass: {
        type: String,
        required: false,
    },
    limitSize: {
        type: Number,
        required: false,
    },
    modelAnswer: {
        type: String,
        required: false,
    },
    name: {
        type: String,
        required: true,
    },
    placeholder: {
        type: Number,
        required: false,
    },
    required: {
        type: Number,
        required: false,
    },
    type: {
        type: String,
        required: true,
    },
    validation: {
        type: Object,
        default: () => ({})
    },
    hasSubmitted: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['input', 'update:modelAnswer']);

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const validationRules = computed(() => {
    return (value) => {
        if (props.validation.required && (!value || value.toString().trim() === '')) {
            return props.errorText || translate('label.this_value_is_required');
        }

        return true;
    };
});

const textPlaceholder = computed(() => {
    if (props.placeholder == true || props.placeholder == 1) {
        return props.label;
    }
    return '';
});

// Solo mostrar errores después del primer submit
const shouldShowError = computed(() => {
    return props.hasSubmitted && errorMessage.value;
});

const modelData = computed({
    get() {
        return props.modelAnswer;
    },
    set(newValue) {
        emit('update:modelAnswer', newValue);
    }
});

// METHODS
const onInput = (event) => {
    const newValue = event.target.value;
    value.value = newValue;

    // Emit the new value to parent component
    emit('input', newValue);
    emit('update:modelAnswer', newValue);
};

// Configurar useField con validación lazy
const { value, errorMessage, meta } = useField(props.name, validationRules, {
    initialValue: props.modelAnswer,
    validateOnValueUpdate: false, // No validar en cada cambio
    validateOnMount: false,       // No validar al montar
});

// LIFECYCLE HOOKS
watch(() => props.modelAnswer, (newValue) => {
    value.value = newValue;
});
</script>
